import { __decorate } from "tslib";
import readyState from 'ready-state';
import { observable } from '@slickdeals/durango/dist/javascript/decorators/observable';
import Logger from '@slickdeals/durango/dist/javascript/utilities/logger';
import DataLayer from '@slickdeals/blueprint-twig/javascript/utilities/dataLayer';
/** The name of the module */
export const name = 'DealDetailsPageViewObservable';
/** The event name fired by this observable */
export const eventName = 'deal_details_page_view';
let DealDetailsPageViewObservable = class DealDetailsPageViewObservable {
    /**
       * Create an Observable instance
       */
    constructor() {
        readyState.domready.then(this.init.bind(this));
    }
    /**
       * Trigger a notification from this observable instance, if threadId exists
       */
    init() {
        DataLayer.get('product').then(value => {
            const data = {
                threadid: value.threadId,
            };
            this.notify(data, eventName);
        }, ({ message }) => {
            Logger.error(message);
        });
    }
};
DealDetailsPageViewObservable = __decorate([
    observable
], DealDetailsPageViewObservable);
export default DealDetailsPageViewObservable;
